/**
 * @description 用户走势图 userTrend
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const userTrendBiz = new Logic()

userTrendBiz.getUserlDataHideLoading = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userTrend.getUserlData,
    data: data
  }, false, true)
}

userTrendBiz.getUserkDataHideLoading = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userTrend.getUserkData,
    data: data
  }, false, true)
}

userTrendBiz.getUserlData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userTrend.getUserlData,
    data: data
  })
}

userTrendBiz.getUserkData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userTrend.getUserkData,
    data: data
  })
}

userTrendBiz.getDeviation = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userTrend.getDeviation,
    data: data
  })
}

userTrendBiz.sendDeviation = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userTrend.sendDeviation,
    data: data
  })
}

userTrendBiz.getOfflineCountry = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userTrend.getOfflineCountry,
    data: data
  })
}

export default userTrendBiz
